<template>
    <div class="link-button-group" :class="classes">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'link-button-group',
        props: {
            shape: {
                type: String,
                default: 'none',
            },
            size: {
                type: String,
                default: 'default',
            },
            vertical: {
                type: Boolean
            },
        },
        computed: {
            classes() {
                return [
                    `link-button-group-shape-${this.shape}`,
                    `link-button-group-size-${this.size}`,
                    `link-button-group-${!!this.vertical ? 'vertical' : 'horizontal'}`,
                    {
                        [`link-button-group-vertical`]: !!this.vertical
                    }
                ];
            },
        },
    };
</script>
